module.exports = __webpack_public_path__ + "static/media/banner-animation.a2a9e773.mp4";